import { graphql } from '@graphql/gql';

export const ME_CONSENT_EXHIBITOR_ANSWER = graphql(`
  # Used to update consent Answer when an answer call is successful
  query ME_CONSENT_EXHIBITOR_ANSWER {
    me {
      id
      exhibitorConsentAnswer {
        attendeeId
        questionId
        questionText
        answerId
        choice {
          text
          id
        }
        locale
        lastModifiedDate
      }
    }
  }
`);
